import { ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredFutureDate, requiredMessage, requiredString } from '@/utils/zodUtils';

export const FlightFormItemSchema = (t: GetTextIdTranslationType) =>
  MinimalFormItemSchema(t).merge(
    z
      .object({
        type: z.literal(ArticleType.FLIGHT),
        description: z.string().optional(),
        departureDate: requiredFutureDate(t),
        reference: requiredFlightReference(t),
        departureAirport: z.object({ iata: requiredString(t), city: requiredString(t) }, requiredMessage(t)),
        destinationAirport: z.object({ iata: requiredString(t), city: requiredString(t) }, requiredMessage(t)),
        passengers: z
          .array(
            z.object({
              documentNumber: requiredPassengerNumber(t),
            }),
          )
          .nonempty(),

        // round trip additional fields
        isRoundTrip: z.boolean().optional(),
        returnDate: requiredFutureDate(t).nullable().optional(),
        returnReference: flightReference(t),
      })
      .strict(),
  );

const requiredPassengerNumber = (t) => {
  return requiredString(t)
    .min(4, {
      message: t('DOCUMENT_NUMBER_SHOULD_HAVE_AT_LEAST_4_CHARACTERS'),
    })
    .max(15, {
      message: t('DOCUMENT_NUMBER_SHOULD_HAVE_MAX_15_CHARACTERS'),
    });
};

const requiredFlightReference = (t) => {
  return requiredString(t)
    .min(3, t('FLIGHT_REFERENCE_SHOULD_HAVE_AT_LEAST_3_CHARACTERS'))
    .max(8, t('FLIGHT_REFERENCE_SHOULD_HAVE_MAX_8_CHARACTERS'));
};

const flightReference = (t) => {
  return z
    .string()
    .optional()
    .refine((val) => !(val && val.length < 3), { message: t('FLIGHT_REFERENCE_SHOULD_HAVE_AT_LEAST_3_CHARACTERS') })
    .refine((val) => !(val && val.length > 8), { message: t('FLIGHT_REFERENCE_SHOULD_HAVE_MAX_8_CHARACTERS') })
    .nullable()
    .optional();
};
